var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.423 6.077a1.173 1.173 0 1 0 0 2.346 1.173 1.173 0 0 0 0-2.346M.75 7.25a2.673 2.673 0 1 1 5.346 0 2.673 2.673 0 0 1-5.346 0M12.077 1.75a1.173 1.173 0 1 0 0 2.346 1.173 1.173 0 0 0 0-2.346M9.404 2.923a2.673 2.673 0 1 1 5.346 0 2.673 2.673 0 0 1-5.346 0M12.077 10.404a1.173 1.173 0 1 0 0 2.346 1.173 1.173 0 0 0 0-2.346m-2.673 1.173a2.673 2.673 0 1 1 5.346 0 2.673 2.673 0 0 1-5.346 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.904 3.097a.75.75 0 0 1-.405.98L4.874 6.414A.75.75 0 1 1 4.3 5.028l5.625-2.336a.75.75 0 0 1 .98.405M3.894 8.491a.75.75 0 0 1 .98-.405l5.625 2.337a.75.75 0 0 1-.575 1.385L4.299 9.472a.75.75 0 0 1-.405-.98",
  clipRule: "evenodd"
})));
export default SvgIconShare02;